import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH3Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH3 extends Component<KuikaH3Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h3 className={classNames("kuika-typography-h3", className)} {...props}>
        {children}
      </h3>
    );
  }
}

export default KuikaH3;
